import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, vModelText as _vModelText, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-302262b4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "practice-dashboard" }
const _hoisted_2 = { class: "overview" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Home", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Practice dashboard", -1))
const _hoisted_5 = { style: {"display":"flex","flex-flow":"row nowrap"} }
const _hoisted_6 = { class: "firm-analysis mr-2" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Firm analysis", -1))
const _hoisted_8 = { class: "mt-4 mb-4" }
const _hoisted_9 = ["onUpdate:modelValue", "disabled"]
const _hoisted_10 = {
  class: "checkbox-elmt",
  style: {"border":"none"}
}
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "checkmark-box" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "checkmark" })
], -1))
const _hoisted_12 = { class: "checkbox-text" }
const _hoisted_13 = { style: {"margin-top":"3em","margin-bottom":"1em"} }
const _hoisted_14 = ["disabled"]
const _hoisted_15 = { key: 1 }
const _hoisted_16 = ["disabled"]
const _hoisted_17 = {
  class: "investigation-list ml-2",
  style: {"flex":"1 1","display":"inline"}
}
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Investigations", -1))
const _hoisted_19 = { class: "file-investigation-list" }
const _hoisted_20 = { class: "date" }
const _hoisted_21 = ["onClick"]
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Notes", -1))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "h3_heading" }, "Law practice notes", -1))
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "h3_heading" }, "Associated entities", -1))
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "h3_heading" }, "Investigator notes", -1))
const _hoisted_26 = { class: "notes" }
const _hoisted_27 = {
  key: 0,
  class: "note-start"
}
const _hoisted_28 = { key: 1 }
const _hoisted_29 = { class: "note-start" }
const _hoisted_30 = ["onClick"]
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", null, [
            _hoisted_7,
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.practiceAnalyses, (pa) => {
              return (_openBlock(), _createElementBlock("div", _hoisted_8, [
                _createElementVNode("label", {
                  class: _normalizeClass(["checkbox-button", _ctx.editPracticeAnalyses ? 'editing': 'read-only'])
                }, [
                  _withDirectives(_createElementVNode("input", {
                    type: "checkbox",
                    "onUpdate:modelValue": $event => ((pa.answer) = $event),
                    disabled: !_ctx.editPracticeAnalyses,
                    onChange: _cache[0] || (_cache[0] = $event => (_ctx.saveCheckPracticeAnalyses()))
                  }, null, 40, _hoisted_9), [
                    [_vModelCheckbox, pa.answer]
                  ]),
                  _createElementVNode("div", _hoisted_10, [
                    _hoisted_11,
                    _createElementVNode("span", _hoisted_12, _toDisplayString(pa.question), 1)
                  ])
                ], 2)
              ]))
            }), 256)),
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("button", {
                disabled: _ctx.editPracticeAnalyses || _ctx.investigations.length == 0,
                class: "btn btn-secondary sml mr-2",
                onClick: _cache[1] || (_cache[1] = $event => (_ctx.viewLastInvestigation()))
              }, " View last investigation", 8, _hoisted_14),
              (!_ctx.editPracticeAnalyses)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    class: "btn btn-outline dark sml ml-2",
                    onClick: _cache[2] || (_cache[2] = $event => (_ctx.editPracticeAnalyses = !_ctx.editPracticeAnalyses))
                  }, "Edit"))
                : (_openBlock(), _createElementBlock("span", _hoisted_15, [
                    _createElementVNode("button", {
                      class: "btn btn-default dark sml ml-2",
                      onClick: _cache[3] || (_cache[3] = (...args) => (_ctx.cancelEditPracticeAnalyses && _ctx.cancelEditPracticeAnalyses(...args)))
                    }, "Cancel"),
                    _createElementVNode("button", {
                      disabled: !_ctx.canSavePracticeAnalyses,
                      class: "btn btn-primary dark sml ml-2",
                      onClick: _cache[4] || (_cache[4] = (...args) => (_ctx.savePracticeAnalyses && _ctx.savePracticeAnalyses(...args)))
                    }, "Save", 8, _hoisted_16)
                  ]))
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_17, [
          _hoisted_18,
          _createElementVNode("ul", _hoisted_19, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.investigations, (i) => {
              return (_openBlock(), _createElementBlock("li", null, [
                _createElementVNode("span", _hoisted_20, _toDisplayString(_ctx.$formatDate(i.commencementDate)), 1),
                _createElementVNode("span", {
                  class: "investigation_info",
                  onClick: $event => (_ctx.showInvestigationDetails(i))
                }, _toDisplayString(i.id) + " " + _toDisplayString(i.investigationType.description), 9, _hoisted_21)
              ]))
            }), 256))
          ]),
          _createElementVNode("button", {
            class: "btn btn-secondary sml",
            onClick: _cache[5] || (_cache[5] = $event => (_ctx.goToAllInvestigations()))
          }, "View all investigations")
        ])
      ])
    ]),
    _createElementVNode("div", null, [
      _hoisted_22,
      _hoisted_23,
      _withDirectives(_createElementVNode("textarea", {
        "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => ((_ctx.lawPracticeNotes) = $event)),
        style: {"resize":"vertical"}
      }, _toDisplayString(_ctx.lawPracticeNotes), 513), [
        [_vModelText, _ctx.lawPracticeNotes]
      ]),
      _createElementVNode("button", {
        class: "btn btn-primary sml",
        onClick: _cache[7] || (_cache[7] = $event => (_ctx.saveLawPracticeNotes()))
      }, "Save"),
      _hoisted_24,
      _withDirectives(_createElementVNode("textarea", {
        "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => ((_ctx.associatedEntitiesContent) = $event)),
        style: {"resize":"vertical"}
      }, _toDisplayString(_ctx.associatedEntitiesContent), 513), [
        [_vModelText, _ctx.associatedEntitiesContent]
      ]),
      _createElementVNode("button", {
        class: "btn btn-primary sml",
        onClick: _cache[9] || (_cache[9] = $event => (_ctx.saveAssociatedEntities()))
      }, "Save"),
      _hoisted_25,
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.notes, (n) => {
        return (_openBlock(), _createElementBlock("div", _hoisted_26, [
          (n.notesType.id == 1)
            ? (_openBlock(), _createElementBlock("span", _hoisted_27, _toDisplayString(n.practiceNote.practiceRisk.name) + " | " + _toDisplayString(n.practiceNote.practiceRiskIndicator.name), 1))
            : (_openBlock(), _createElementBlock("div", _hoisted_28, [
                _createElementVNode("span", _hoisted_29, [
                  _createElementVNode("i", null, [
                    _createElementVNode("b", {
                      class: "link",
                      onClick: $event => (_ctx.showInvestigationDetailsByNote(n.investigationNote?.investigation))
                    }, _toDisplayString(n.investigationNote?.investigationType?.description), 9, _hoisted_30),
                    _createTextVNode(", - " + _toDisplayString(n.trustTeamMember?.displayName) + " " + _toDisplayString(_ctx.$formatDateTimeTypeA(n.createdOn)), 1)
                  ])
                ])
              ])),
          _createTextVNode(" " + _toDisplayString(n.content) + " ", 1),
          _hoisted_31
        ]))
      }), 256)),
      _createElementVNode("div", null, [
        _createElementVNode("button", {
          class: "btn btn-secondary sml",
          onClick: _cache[10] || (_cache[10] = $event => (_ctx.viewAllInvestigatorNotes()))
        }, "View all investigator notes")
      ])
    ])
  ]))
}